module.exports = "<div class=\"register\">\n  <h4>Access denied</h4>\n</div>\n"